document.addEventListener("DOMContentLoaded", function() {
    const linkedProducts = document.querySelector('.linkedProducts__wrapper');
    const linkedProductsSlider = new Flickity(linkedProducts, {
        cellAlign: "left",
        freeScroll: true,
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true
    });
    
    const productCountdownTimer = document.querySelector('.countdownTimer__text');
    let displayCountdownDay,displayCountdownTime;
    let clocktimer;
    const test = new Date();
    const now = test.getTime();
    let countdownFrom = new Date();
    
    function numberToWeekday(number){
        const   weekday = new Array(7);
                weekday[0] = countDownObj.weekdays.sunday;
                weekday[1] = countDownObj.weekdays.monday;
                weekday[2] = countDownObj.weekdays.tuesday;
                weekday[3] = countDownObj.weekdays.wednesday;
                weekday[4] = countDownObj.weekdays.thursday;
                weekday[5] = countDownObj.weekdays.friday;
                weekday[6] = countDownObj.weekdays.saturday;
    
        if(number == test.getDay()) {
            return countDownObj.weekdays.today;
        } else {
            return weekday[number];
        }
    }
    
    function getTimerDisplay(from, day, starttimer) {
        const now = Math.round(Date.now());
        const dist = from.getTime() - now;
      
        const days = Math.floor(dist / (1000 * 60 * 60 * 24));
        const hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((dist % (1000 * 60)) / 1000);
        
        let timeOutput = '';
    
        if(days != 0) {
            if(days == 1 ) {
                timeOutput += `${days} ${countDownObj.timer_text.day} `;
            } else {
                timeOutput += `${days} ${countDownObj.timer_text.days} `;
            }
        }
    
        if(hours != 0) {
            if(hours == 1 ) {
                timeOutput += `${hours} ${countDownObj.timer_text.hour} `;
            } else {
                timeOutput += `${hours} ${countDownObj.timer_text.hours} `;
            }
        }
    
        if(minutes != 0) {
            if(minutes == 1 ) {
                timeOutput += `${minutes} ${countDownObj.timer_text.minute} `;
            } else {
                timeOutput += `${minutes} ${countDownObj.timer_text.minutes} `;
            }
        }
    
        if(seconds != 0) {
            if(seconds == 1 ) {
                timeOutput += `${seconds} ${countDownObj.timer_text.second}`;
            } else {
                timeOutput += `${seconds} ${countDownObj.timer_text.seconds}`;
            }
        }
    
        if (dist < 0 && starttimer) {
            stopTimer();
            startTimer(true);
        } else {
            displayCountdownTime.innerHTML = timeOutput;
        }
    }
    function stopTimer() {
        clearInterval(clocktimer);
    }
    function initializeTimer(from, day) {   
        clocktimer = setInterval(function() {
            getTimerDisplay(from, day, true)
        }, 1000)
    }
    
    function calculateCountdown(hour, minute, day) {
        countdownFrom.setHours( hour );
        countdownFrom.setMinutes( minute );
        countdownFrom.setSeconds( 0 );
        const dist = countdownFrom.getTime() - now;
    
        if(dist < 0) {
            startTimer(true)
        } else {
            getTimerDisplay(countdownFrom, countdownFrom.getDay(), false)
            initializeTimer(countdownFrom, countdownFrom.getDay())
            displayCountdownDay.innerHTML = numberToWeekday(day);
        }
    }
    
    function startTimer(repeat) {
        
        if(repeat) {
            countdownFrom.setDate(countdownFrom.getDate() + 1);
        }
    
        let day = countdownFrom.getDay();
        
        const deadlineMonday = countDownObj.orderby.monday.split(':');
        const deadlineTuesday = countDownObj.orderby.tuesday.split(':');
        const deadlineWednesday = countDownObj.orderby.wednesday.split(':');
        const deadlineThursday = countDownObj.orderby.thursday.split(':');
        const deadlineFriday = countDownObj.orderby.friday.split(':');
        const deadlineSaturday = countDownObj.orderby.saturday.split(':');
        const deadlineSunday = countDownObj.orderby.sunday.split(':');
    
        switch (day) {
            case 0:
                if(deadlineSunday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineSunday[0],deadlineSunday[1],day);                    
                }
              break;
            case 1:
                if(deadlineMonday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineMonday[0],deadlineMonday[1],day);  
                }
              break;
            case 2:
                if(deadlineTuesday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineTuesday[0],deadlineTuesday[1],day);  
                }
              break;
            case 3:
                if(deadlineWednesday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineWednesday[0],deadlineWednesday[1],day);  
                }
              break;
            case 4:
                if(deadlineThursday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineThursday[0],deadlineThursday[1],day);  
                }
              break;
            case 5:
                if(deadlineFriday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineFriday[0],deadlineFriday[1],day);  
                }
              break;
            case 6:
                if(deadlineSaturday=='') {
                    startTimer(true);
                } else {
                    calculateCountdown(deadlineSaturday[0],deadlineSaturday[1],day);  
                }
          }
    }
    
    if(productCountdownTimer != undefined) {
        const newTimeText = productCountdownTimer.innerHTML.replace('[time]', '<span id="countdownTime"></span>');
        productCountdownTimer.innerHTML = newTimeText;
    
        const newDateText = productCountdownTimer.innerHTML.replace('[day]', '<span id="countdownDay"></span>');
        productCountdownTimer.innerHTML = newDateText;
    
        displayCountdownDay = document.querySelector('#countdownDay');
        displayCountdownTime = document.querySelector('#countdownTime');
        
        startTimer(false);
    }
});